import { render, staticRenderFns } from "./DialogYesNo.vue?vue&type=template&id=715277e1&"
import script from "./DialogYesNo.vue?vue&type=script&lang=js&"
export * from "./DialogYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports